import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
// ** API Imports
import axios from '@src/service/axios';
import { toast } from 'react-toastify';
import queryString from 'query-string';

export const getAllVillage = createAsyncThunk('villageSlice/getVillage', async () => {
    try {
        let response = await axios.get('/village', {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getAllVillageOptions = createAsyncThunk('villageSlice/getAllVillageOptions', async (data) => {
    try {
        const query = queryString.stringify(data);
        let response = await axios.get('/village/options' + `${data ? `?${query}` : ''}`, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: false
        });
        return Promise.resolve(response?.data?.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const createVillage = createAsyncThunk('villageSlice/createVillage', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.post('/village', data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Village added successfully.');
        await dispatch(getAllVillage());
        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const updateVillage = createAsyncThunk('villageSlice/updateVillage', async (data, { dispatch, rejectWithValue }) => {
    try {
        let response = await axios.put('/village/' + data.id, data?.data, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Village updated successfully.');
        dispatch(getAllVillage());

        return Promise.resolve(response.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return rejectWithValue(err);
    }
});

export const deleteVillage = createAsyncThunk('villageSlice/deleteVillage', async (deleteId, { dispatch }) => {
    try {
        let response = await axios.delete('/village/' + deleteId, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Village deleted successfully.');
        await dispatch(getAllVillage());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});
export const updateStatus = createAsyncThunk('villageSlice/updateStatus', async (id, { dispatch }) => {
    try {
        let response = await axios.put('/village/status/' + id, undefined, {
            headers: {
                'Content-Type': 'application/json'
            },
            loader: true
        });
        toast.success(response?.data?.message || 'Village Status updated successfully !');
        dispatch(getAllVillage());
        return Promise.resolve(response);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const getVillageById = createAsyncThunk('villageSlice/getVillageById', async ({ id, isDashboard = false }) => {
    try {
        let response = await axios.get('/village/' + id, {
            headers: {
                'Content-Type': 'application/json'
            },
            params: { isDashboard }
        });
        return Promise.resolve(response.data.data);
    } catch (err) {
        toast.error(err?.response?.data?.message || 'Something went wrong!');
        return Promise.reject(err);
    }
});

export const villageSlice = createSlice({
    name: 'villageSlice',
    initialState: {
        data: [],
        options: []
    },

    extraReducers: (builder) => {
        builder.addCase(getAllVillage.fulfilled, (state, action) => {
            state.data = action?.payload;
            return;
        });
        builder.addCase(getAllVillageOptions.fulfilled, (state, action) => {
            state.options = action?.payload;
            return;
        });
    }
});

export default villageSlice.reducer;
